import { Auth } from "aws-amplify";

export const login = ({ email, password }) => {
  return Auth.signIn(email, password);
};
